import 'focus-visible'
import 'alpinejs'
import 'flickity-fade'
import 'flickity-imagesloaded'
import Cookies from 'js-cookie'
import GLightbox from 'glightbox'
import flatpickr from 'flatpickr'

window.Cookies = Cookies
window.GLightbox = GLightbox({ selector: '*[data-glightbox]', skin: 'modern' })
window.flatpickr = flatpickr
